import axios from "axios";
import { getActiveUsers } from "./GetActiveUsersAction";
import {
  grantUserRolesRequested,
  grantUserRolesRequestSucceeded,
  grantUserRolesRequestFailed,
} from "../slices/GrantUserRolesSlice";

const apiUrl = `${process.env.REACT_APP_BASE_API_URL}/api/User/GrantUserRoles`;

const ApiKey = process.env.REACT_APP_BASE_API_KEY;

export const GrantUserRoles = (idUser, roleIds) => async (dispatch) => {
  try {
    dispatch(grantUserRolesRequested());

    const postData = {
      idUser: Number(idUser),
      roleIds: roleIds.map((id) => Number(id)),
    };

    const axiosConfig = {
      headers: {
        ApiKey: ApiKey,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(apiUrl, postData, axiosConfig);

    if (response.data === true) {
      dispatch(grantUserRolesRequestSucceeded(response.data));
      await dispatch(getActiveUsers());
      return { success: true, message: "Roles granted successfully" };
    }

    const errorMessage =
      "The roles could not be granted. The user may not exist or the roles are already assigned.";
    dispatch(grantUserRolesRequestFailed(errorMessage));

    return { success: false, message: errorMessage };
  } catch (error) {
    const errorMessage = error.response?.data || error.message;
    dispatch(grantUserRolesRequestFailed(errorMessage));

    return {
      success: false,
      message: errorMessage,
    };
  }
};
